export function isDraftAgent(agent) {
  return ['inactive', 'archived'].includes(agent.status) && !agent.published_version_id && !agent.test_version_id && (agent.current_version === undefined ? 0 : agent.current_version) === 0;
}
export function matchesDraft(agent, query) {
  const normalize = (s) => String(s || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('fr');
  return normalize([agent.name, agent.draft?.description].join(' ')).includes(normalize(query.trim()));
}
